export default __webpack_public_path__ + "700e52c55b617e65675a7cc0e2b57a3e.jpg";